type ExpectedAsAString = string | null | undefined | string[];

interface IStringifyOptions {
  strategy?: "join" | "first";
}

export const stringify = (
  mixed: ExpectedAsAString,
  options?: IStringifyOptions
): string => {
  const strategy = (options && options.strategy) || "join";

  if (Array.isArray(mixed)) {
    switch (strategy) {
      case "join":
        return mixed.join(", ");
      case "first":
        if (mixed.length) {
          return stringify(mixed[0]);
        }

        return "";
    }
  }

  if (typeof mixed === "string") {
    return mixed;
  }

  return "";
};

export const stripHtml = (html: string): string => {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;

  return tmp.textContent || tmp.innerText || "";
};
